var _defs, _mask, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHouseSitting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.437 37.643C45.803 36.493 46 35.27 46 34c0-6.627-5.373-12-12-12-1.36 0-2.69.227-3.95.666a1 1 0 01-1.036-.237L8.586 2H2v6.586l3.707 3.707A1 1 0 016 13v5h5a1 1 0 011 1v5h5a1 1 0 01.707.293l4.722 4.721a1 1 0 01.237 1.037A11.977 11.977 0 0022 34c0 6.627 5.373 12 12 12 1.27 0 2.494-.197 3.643-.563.017-.019.036-.037.055-.055.894-.828 1.497-2.197 1.78-3.721-2.518-.03-5.006-.784-6.559-2.337-1.693-1.693-1.62-4.48.116-6.246a1.32 1.32 0 01.043-.043c1.765-1.736 4.553-1.809 6.246-.116 1.553 1.553 2.307 4.041 2.337 6.559 1.524-.283 2.893-.886 3.72-1.78.019-.02.037-.038.056-.055zm-1.672 3.334c-.706.251-1.462.435-2.24.548a11.767 11.767 0 01-.548 2.24 12.069 12.069 0 002.788-2.788zM38 2.063a6 6 0 11-3 11.194 1 1 0 010-1.73c1.228-.712 2-2.02 2-3.464a3.996 3.996 0 00-2-3.464 1 1 0 01-.001-1.731A5.973 5.973 0 0138 2.063zm0 10a4 4 0 10-.5-7.97 5.986 5.986 0 011.5 3.97 5.986 5.986 0 01-1.5 3.968c.164.021.331.031.5.031zM4.855 6.144A1 1 0 016.27 4.73l19.25 19.25a1 1 0 01-1.415 1.415L4.855 6.145zM34 20c7.732 0 14 6.268 14 14s-6.268 14-14 14-14-6.268-14-14c0-1.37.198-2.715.582-4.004L16.586 26H11a1 1 0 01-1-1v-5H5a1 1 0 01-1-1v-5.586L.293 9.707A1 1 0 010 9V1a1 1 0 011-1h8a1 1 0 01.707.293l20.29 20.29A13.992 13.992 0 0134 20zm3.91 14.334c-.9-.9-2.439-.857-3.44.137-.993 1-1.037 2.539-.136 3.439 1.195 1.195 3.255 1.757 5.328 1.752.005-2.073-.557-4.133-1.752-5.328z",
    id: "house-sitting_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "house-sitting_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#house-sitting_svg__a"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: props.color,
    fillRule: "nonzero",
    xlinkHref: "#house-sitting_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#house-sitting_svg__b)",
    fill: props.color
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v47.892H0z"
  })))));
}

export default SvgHouseSitting;